import { render, staticRenderFns } from "./XhProuctCate.vue?vue&type=template&id=66eea40f&scoped=true&"
import script from "./XhProuctCate.vue?vue&type=script&lang=js&"
export * from "./XhProuctCate.vue?vue&type=script&lang=js&"
import style0 from "./XhProuctCate.vue?vue&type=style&index=0&id=66eea40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eea40f",
  null
  
)

component.options.__file = "XhProuctCate.vue"
export default component.exports